import easeChat from './easeChat.vue'
const plug = {
  install (Vue, options) {
    Vue.component(easeChat.name, easeChat)
  }
};

// 新增
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(easeChat);
}

export default plug // 导出.



// WEBPACK FOOTER //
// ./src/lib/index.js